export const getContactPersonNumber = (customText = "") => {
	// Admisi 1: +62 878-3929-7479
	// Admisi 2: +62 877-7615-3794
	let text = "";
	if (customText !== "") {
		text = "?text=" + customText;
	} else {
		text =
			"?text=Halo%20kak%2C%20Saya%20barusan%20membuka%20website%20brofesional.id%2C%20dan%20membutuhkan%20info%20tentang%20";
	}

	const now = new Date();
	const hour = now.getHours();
	const minute = now.getMinutes();
	const time = hour + minute / 60;
	const isTime1 = time >= 2 && time <= 14; // 2 AM - 2 PM
	return isTime1 ? "6287839297479" + text : "6287776153794" + text;
	// return "6287839297479" + text;
};
